
<template>
    <div>
        <el-form :inline="true" :model="searchForm">
            <el-form-item label="分销商姓名：">
                <el-input v-model="searchForm.agentName"  @keyup.enter.native="getSimDistributRecordHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="批次：">
                <el-input v-model="searchForm.batchNo" @input="handleInput" @keyup.enter.native="getSimDistributRecordHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="分销时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" plain icon="el-icon-search" @click="getSimDistributRecordHandler">查询</el-button>
                <el-button type="success" plain icon="el-icon-s-ticket" @click="showSimExcelDistribut">分销SIM卡</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border
		 fit
		 highlight-current-row
		 style="width: 100%;"
		 :header-cell-style="{background:'#f5f5f5'}">
            <el-table-column prop="startIccid" label="开始ICCID号" align="center"></el-table-column>
            <el-table-column prop="endIccid" label="结束ICCID号" align="center"></el-table-column>
            <el-table-column prop="agentName" label="分销商姓名" align="center"></el-table-column>
            <el-table-column prop="batchNo" label="分销批次" align="center"></el-table-column>
            <el-table-column prop="soldTotal" label="分销张数（张）" align="center"></el-table-column>
            <el-table-column prop="soldSuccess" label="分销成功张数（张）" width="140" align="center"></el-table-column>
            <el-table-column prop="soldFail" label="分销失败张数（张）" align="center" width="140"></el-table-column>
            <el-table-column prop="createTime" label="分销时间" align="center"></el-table-column>            
            <el-table-column prop="createOptName" label="操作人" align="center"></el-table-column>            
            <el-table-column label="操作" align="center" fixed="right">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.soldFail > 0" type="text" size="small" @click="getSimDistributFailRecordListHandler(scope.row.id, $event)">查看失败</el-button>
                </template> 
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>    
        <el-dialog :append-to-body="true"  title="分销失败卡列表" :visible.sync="distributFailVisible" width="1000px" :close-on-click-modal="false">
            <el-table :data="tbpg_fail.tableData" border height="421">
                <el-table-column prop="iccid" label="ICCID号" width="200px"></el-table-column>
                <el-table-column prop="intoNo" label="接入号" width="200px"></el-table-column>
                <el-table-column prop="failReason" label="错误描述"></el-table-column>
            </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg_fail.currentPage"
            :page-sizes="[10, 50, 100, 500]"
            :page-size="tbpg_fail.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg_fail.total">
        </el-pagination> 
        </el-dialog>
        <el-dialog :append-to-body="true"  title="卡片批量分销" :visible.sync="batchDstVisible" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="batchDistributForm" :model="batchDistributForm" label-width="120px">
                <el-form-item label="导入Excel：">
                    <el-upload ref="upload" :action="uploadUrl('sim/soldList/excel')" :headers="setHeader()" :limit="1" :auto-upload="false" :multiple="false" :data="batchDistributForm" :on-success = 'handleSuccess'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="exportExcel('/mould/download?type=sold')">导出模板</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="代理商：">
                    <el-select v-model="batchDistributForm.agentId" filterable clearable>
                        <el-option v-for="item in agentListOption" :value="item.id" :key="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="simDistributHandler">确 定</el-button>
            </div> 
        </el-dialog> 
    </div>
</template>
<script>
import {getSimDistributRecord, getSimDistributFailRecordList} from '@/api/sim.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                agentName: '',
                batchNo: '',
                time: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0                
            },
            distributFailVisible: false,
            tbpg_fail: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0                
            },      
            currentId_fail: '',
            batchDstVisible: false,
            batchDistributForm: {
                agentId: ''
            },
            agentListOption: []
        }
    },
    methods: {
        handleInput(e){
            this.searchForm.batchNo = this.searchForm.batchNo.replace(/[^\d]/g,'');
        },
        cancel(){            
            this.batchDstVisible = false;    
            this.$refs.batchDistributForm.resetFields();  
        },
        getSimDistributRecordHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            getSimDistributRecord(data).then(res => {
                common.listCallback(this, res, 'tbpg');               
            })            
        },
        getSimDistributFailRecordListHandler(id, $event){
            this.distributFailVisible = true;
            this.currentId_fail = id;
            var searchForm = {
                recordId: this.currentId_fail 
            }
            common.resetCurrentPage(this, $event, 'tbpg_fail');
            var data = common.getRequestParams(this, 'tbpg_fail', searchForm);
            getSimDistributFailRecordList(data).then(res => {
                common.listCallback(this, res, 'tbpg_fail');
            })
        },
        showSimExcelDistribut(){
            this.batchDstVisible = true;
            common.getAgentListOptionCom(this, 'agentListOption');         
        },
        simDistributHandler(){
            this.$refs.upload.submit();   //excel批量导入
        },
        handleSuccess(res){
            if(res.code == 200){
                this.batchDstVisible = false;
                this.getSimDistributRecordHandler();
                this.$refs.upload.clearFiles();
                this.$message.success(res.message);
            }else{
                this.$message.error(res.message);
            }
        },
        handleSizeChange(val){
            if(this.distributFailVisible){
                this.tbpg_fail.pageSize = val;
                this.getSimDistributFailRecordListHandler(this.currentId_fail);
            }else{
                this.tbpg.pageSize = val;
                this.getSimDistributRecordHandler();
            }
        },
        handleCurrentChange(val){
            if(this.distributFailVisible){
                this.tbpg_fail.currentPage = val;
                this.getSimDistributFailRecordListHandler(this.currentId_fail);
            }else{
                this.tbpg.currentPage = val;
                this.getSimDistributRecordHandler();
            }
        }  
    },   
    created () {
        this.getSimDistributRecordHandler()
    } 
}
</script>
<style lang="less" scoped>

</style>

